(function () {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function isMobile() {
    return window.matchMedia("(max-width: 989px)").matches;
  }

  class VerticalScrollerSlideshow {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector(".vss__viewport");
      this.track = root.querySelector("[data-vss-track]");
      this.slides = Array.from(root.querySelectorAll("[data-vss-slide]"));

      this.navBtns = Array.from(root.querySelectorAll("[data-vss-nav]"));
      this.menuBtns = Array.from(root.querySelectorAll("[data-vss-menu] [data-vss-nav]"));
      this.dots = Array.from(root.querySelectorAll("[data-vss-dots] .vss__dot"));
      this.mobileTitleText = root.querySelector("[data-vss-mobile-title-text]");

      this.total = this.slides.length;
      this.index = 0;

      // Hardcoded settings
      this.animationMs = 520;
      this.wheelThreshold = 40; // <- vuelve a un valor sano
      this.touchThreshold = 60;
      this.swipeVelocity = 900;

      this.offsetDesktop = parseInt(root.dataset.offsetDesktop || "80", 10);
      this.offsetMobile = parseInt(root.dataset.offsetMobile || "64", 10);

      // State
      this.isAnimating = false;
      this.wheelAccum = 0;
      this.wheelTimer = null;

      this.dragging = false;
      this.dragStartY = 0;
      this.dragDeltaY = 0;
      this.dragStartTime = 0;
      this.preventClick = false;

      // Body lock
      this.locked = false;
      this._savedScrollY = 0;

      // Snap/exit flags
      this.snapLockThreshold = 0.10;
      this.isSnapping = false;
      this.isExiting = false;
      this.lastScrollY = window.scrollY || window.pageYOffset || 0;

      // Bind
      this.onWheel = this.onWheel.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onScroll = this.onScroll.bind(this);

      this.init();
    }

    init() {
      if (!this.viewport || !this.track || !this.total) return;

      this.updateHeightVar();
      this.updateUI();
      this.applyTransform(-this.index * this.getHeight(), false);

      // Nav clicks
      this.navBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            console.log("clicked nav:", btn, btn.getAttribute("data-vss-nav"));

          e.preventDefault();
          if (this.isAnimating || this.isSnapping || this.isExiting) return;
          const attr = btn.getAttribute("data-vss-nav");
            const to = Number(attr);

            if (!Number.isFinite(to)) return; // ✅ si no es número, no hacemos nada
            this.goTo(to, true);

          // si navegas por menú, aseguramos lock (porque estás “usando” la sección)
          this.lockBody();
        });
      });

      // Prevent click after drag
      this.root.addEventListener(
        "click",
        (e) => {
            // ✅ Nunca canceles clicks del menú / dots
            if (e.target.closest(".vss__menu") || e.target.closest("[data-vss-dots]")) {
            this.preventClick = false;
            return;
            }

            if (!this.preventClick) return;
            e.preventDefault();
            e.stopPropagation();
            this.preventClick = false;
        },
        true
        );


      // Wheel/drag solo dentro de la sección
      this.viewport.addEventListener("wheel", this.onWheel, { passive: false });
      this.viewport.addEventListener("pointerdown", this.onPointerDown, { passive: false });

      window.addEventListener("resize", this.onResize);
      document.addEventListener("keydown", this.onKeyDown);

      // Snap al volver desde abajo (scroll del documento)
      window.addEventListener("scroll", this.onScroll, { passive: true });
    }

    destroy() {
      if (this.viewport) {
        this.viewport.removeEventListener("wheel", this.onWheel);
        this.viewport.removeEventListener("pointerdown", this.onPointerDown);
        this.viewport.removeEventListener("pointermove", this.onPointerMove);
        this.viewport.removeEventListener("pointerup", this.onPointerUp);
        this.viewport.removeEventListener("pointercancel", this.onPointerUp);
      }
      window.removeEventListener("resize", this.onResize);
      document.removeEventListener("keydown", this.onKeyDown);
      window.removeEventListener("scroll", this.onScroll);
      window.clearTimeout(this._animTimer);
      window.clearTimeout(this._snapTimer);
      this.unlockBody();
    }

    getOffset() {
      return isMobile() ? this.offsetMobile : this.offsetDesktop;
    }

    getHeight() {
      const h = (window.innerHeight || 0) - this.getOffset();
      return Math.max(240, h);
    }

    updateHeightVar() {
      const slideHeight = this.getHeight(); // altura total de una slide
      const h = `${slideHeight}px`;

      // Variables base
      this.root.style.setProperty("--vss-height", h);
      document.documentElement.style.setProperty("--vss-height-global", h);

      // Solo desktop
      if (isMobile()) return;

      // Section a restar (ej: newsletter / banner / lo que sea)
      const extraSection = document.querySelector('.new-review-section');
      const extraHeight = extraSection
        ? extraSection.getBoundingClientRect().height
        : 0;

      // Footer wrapper real (Shopify)
      const footerSection = document.querySelector('footer.shopify-section--footer');
      if (!footerSection) return;

      // Altura final del footer
      const footerHeight = Math.max(240, slideHeight - extraHeight);

      footerSection.style.minHeight = `${footerHeight}px`;
    }


    onResize() {
      this.updateHeightVar();
      this.applyTransform(-this.index * this.getHeight(), false);
    }

    onKeyDown(e) {
      if (this.isAnimating || this.isSnapping || this.isExiting) return;
      if (!this.locked) return; // solo si estás “dentro” de la sección
      if (e.key === "ArrowDown") {
        e.preventDefault();
        this.next(true);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        this.prev(true);
      }
    }

    updateUI() {
      this.menuBtns.forEach((b) => b.classList.remove("is-active"));
      const activeMenu = this.menuBtns.find((b) => parseInt(b.dataset.vssNav, 10) === this.index);
      if (activeMenu) activeMenu.classList.add("is-active");

      this.dots.forEach((d, i) => d.classList.toggle("is-active", i === this.index));

      const slide = this.slides[this.index];
      let title = "";
      if (slide && slide.dataset && slide.dataset.vssTitle) {
        title = String(slide.dataset.vssTitle).trim();
      }

      if (!title) title = `Slide ${this.index + 1}`;
      if (this.mobileTitleText) this.mobileTitleText.textContent = title;

      this.slides.forEach((s, i) => s.setAttribute("aria-hidden", i === this.index ? "false" : "true"));
    }

    applyTransform(yPx, withTransition) {
      this.track.style.transition = withTransition
        ? `transform ${this.animationMs}ms cubic-bezier(.22,.61,.36,1)`
        : "none";
      this.track.style.transform = `translate3d(0, ${yPx}px, 0)`;
    }

    goTo(toIndex, animate) {
      const target = clamp(toIndex, 0, this.total - 1);
      if (this.isAnimating || this.isSnapping || this.isExiting) return;

      if (target === this.index) {
        this.applyTransform(-this.index * this.getHeight(), !!animate);
        this.updateUI();
        return;
      }

      this.isAnimating = true;
      this.index = target;

      this.updateUI();
      this.applyTransform(-this.index * this.getHeight(), !!animate);

      window.clearTimeout(this._animTimer);
      this._animTimer = window.setTimeout(() => {
        this.isAnimating = false;
        this.track.style.transition = "none";
      }, this.animationMs + 30);
    }

    next(animate) {
      this.goTo(this.index + 1, animate);
    }

    prev(animate) {
      this.goTo(this.index - 1, animate);
    }

    // ---- Lock body (temporal) ----
    lockBody() {
      if (this.locked) return;
        this.locked = true;

        this.root.classList.remove("not-active"); // ✅ menú visible

        this._savedScrollY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.classList.add("vss-lock");
        document.body.style.top = `-${this._savedScrollY}px`;
    }

    unlockBody() {
      if (!this.locked) return;
      this.locked = false;
        this.root.classList.add("not-active"); // ✅ menú oculto
      document.documentElement.classList.remove("vss-lock");
      const y = this._savedScrollY || 0;
      document.body.style.top = "";
      window.scrollTo(0, y);
    }

    // ---- Shared animated scroll ----
    animateWindowScroll(from, to, duration) {
      const start = performance.now();
      const ease = (t) => 1 - Math.pow(1 - t, 3); // similar a vuestra curva

      const step = (ts) => {
        const t = Math.min(1, (ts - start) / duration);
        const y = from + (to - from) * ease(t);
        window.scrollTo(0, y);
        if (t < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    }

    // ---- Exit down (from last slide) ----
    exitDownAnimated() {
      if (this.isExiting) return;
      this.isExiting = true;

      this.unlockBody();

      const from = window.scrollY || window.pageYOffset || 0;
      const to = from + this.getHeight();

      this.animateWindowScroll(from, to, this.animationMs);

      window.clearTimeout(this._exitTimer);
      this._exitTimer = window.setTimeout(() => {
        this.isExiting = false;
      }, this.animationMs + 40);
    }

    // ---- Wheel ----
    onWheel(e) {
      if (this.isSnapping || this.isExiting) return;

      const dir = e.deltaY > 0 ? 1 : -1;
      const atLast = this.index === this.total - 1;

      // si estamos en el último y quieren seguir bajando -> salir de la sección
      if (dir > 0 && atLast) {
        this.exitDownAnimated();
        return;
      }

      // dentro de la sección: capturamos
      e.preventDefault();
      this.lockBody();

      if (this.isAnimating) return;

      this.wheelAccum += e.deltaY;

      window.clearTimeout(this.wheelTimer);
      this.wheelTimer = window.setTimeout(() => {
        this.wheelAccum = 0;
      }, 140);

      if (Math.abs(this.wheelAccum) < this.wheelThreshold) return;

      const d = this.wheelAccum > 0 ? 1 : -1;
      this.wheelAccum = 0;

      if (d > 0) this.next(true);
      else this.prev(true);
    }

    // ---- Pointer drag (mobile) ----
    onPointerDown(e) {
      if (e.pointerType === "mouse") return;

         if (e.target.closest(".vss__menu")) return;
      if (this.isSnapping || this.isExiting) return;
      if (e.pointerType === "mouse" && e.button !== 0) return;
      if (this.isAnimating) return;

      this.lockBody();

      try {
        this.viewport.setPointerCapture(e.pointerId);
      } catch (_) {}

      this.dragging = true;
      this.preventClick = false;

      this.dragStartY = e.clientY;
      this.dragDeltaY = 0;
      this.dragStartTime = performance.now();

      this.track.style.transition = "none";

      this.viewport.addEventListener("pointermove", this.onPointerMove, { passive: false });
      this.viewport.addEventListener("pointerup", this.onPointerUp, { passive: false });
      this.viewport.addEventListener("pointercancel", this.onPointerUp, { passive: false });
    }

    onPointerMove(e) {
      if (!this.dragging) return;
      e.preventDefault();

      const y = e.clientY;
      this.dragDeltaY = y - this.dragStartY;

      if (Math.abs(this.dragDeltaY) > 6) this.preventClick = true;

      const baseY = -this.index * this.getHeight();
      const nextY = baseY + this.dragDeltaY;

      const minY = -(this.total - 1) * this.getHeight();
      const maxY = 0;

      let resistedY = nextY;
      if (nextY > maxY) resistedY = maxY + (nextY - maxY) * 0.25;
      if (nextY < minY) resistedY = minY + (nextY - minY) * 0.25;

      this.applyTransform(resistedY, false);
    }

    onPointerUp() {
      if (!this.dragging) return;
      this.preventClick = false; // ✅ reset al soltar
      this.dragging = false;
      this.viewport.removeEventListener("pointermove", this.onPointerMove);
      this.viewport.removeEventListener("pointerup", this.onPointerUp);
      this.viewport.removeEventListener("pointercancel", this.onPointerUp);

      const endTime = performance.now();
      const dt = Math.max(1, endTime - this.dragStartTime);
      const dy = this.dragDeltaY;
      const velocity = (dy / dt) * 1000;

      const absDy = Math.abs(dy);
      const absVel = Math.abs(velocity);

      const atLast = this.index === this.total - 1;
      const wantsChange = (absDy >= this.touchThreshold) || (absVel >= this.swipeVelocity);

      // salir por abajo desde mobile (dy < 0 = swipe up)
      if (wantsChange && atLast && dy < 0) {
        this.exitDownAnimated();
        this.applyTransform(-this.index * this.getHeight(), true);
        return;
      }

      let target = this.index;

      if (wantsChange) {
        if (dy < 0) target = this.index + 1;
        if (dy > 0) target = this.index - 1;
      }

      target = clamp(target, 0, this.total - 1);
      this.goTo(target, true);
    }

    // ---- Snap when coming back up ----
    onScroll() {
      if (this.locked || this.isSnapping || this.isExiting) {
        this.lastScrollY = window.scrollY || window.pageYOffset || 0;
        return;
      }

      const currentY = window.scrollY || window.pageYOffset || 0;
      const scrollingUp = currentY < this.lastScrollY;
      this.lastScrollY = currentY;

      if (!scrollingUp) return;

      const rect = this.root.getBoundingClientRect();
const vh = window.innerHeight || 0;

const isPartiallyVisible = rect.top < vh && rect.bottom > 0;

const offset = this.getOffset();
const notAligned = Math.abs(rect.top - offset) > 2;

const visiblePx = Math.min(vh, rect.bottom) - Math.max(0, rect.top);
const visibleRatio = visiblePx / vh;

if (!isPartiallyVisible || !notAligned) return;
if (visibleRatio < this.snapLockThreshold) return;

this.isSnapping = true;

const sectionTopAbs = rect.top + currentY;
const from = currentY;

// ✅ Snap al punto que deja visible el header
const to = Math.max(0, sectionTopAbs - offset);

this.animateWindowScroll(from, to, this.animationMs);

window.clearTimeout(this._snapTimer);
this._snapTimer = window.setTimeout(() => {
  window.scrollTo(0, to);
  this.lockBody();
  this.applyTransform(-this.index * this.getHeight(), false);
  this.isSnapping = false;
}, this.animationMs + 40);

    }
  }

  function initAll() {
    document.querySelectorAll(".vss").forEach((root) => {
      if (root.__vssInstance) return;
      root.__vssInstance = new VerticalScrollerSlideshow(root);
    });
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);

  document.addEventListener("shopify:section:unload", (e) => {
    const sectionEl = e.target;
    if (!sectionEl || !sectionEl.classList.contains("vss")) return;

    const inst = sectionEl.__vssInstance;
    if (inst && typeof inst.destroy === "function") inst.destroy();

    document.documentElement.classList.remove("vss-lock");
    document.body.style.top = "";
  });
})();
